"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _columnTypes = _interopRequireDefault(require("./columnTypes"));
var _rowTypes = _interopRequireDefault(require("./rowTypes"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdSurveyMultipleChoice = require("cccisd-survey-multiple-choice");
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = function () {
  var result = [];

  // Column types
  (0, _forEach2["default"])(_columnTypes["default"], function (columnType, name) {
    columnType.fields.forEach(function (field) {
      result.push("columnTypes.".concat(name, "[].").concat(field));
    });
  });

  // Row types
  (0, _forEach2["default"])(_rowTypes["default"], function (rowType, name) {
    rowType.fields.forEach(function (field) {
      result.push("rowTypes.".concat(name, "[].").concat(field));
    });
  });
  return ['question', 'description',
  // Options
  'allowUserRows', 'addUserRowText', 'userRowPlaceholder', 'minUserRows', 'maxUserRows', 'rowPrefix', 'rowHeaderWidth', 'cornerHeader', 'isBorderedStyle', 'isStripedRowsStyle', 'isStripedColumnsStyle', 'questionNumbersExpanded', 'questionNumbersHide', 'questionNumbersForMainQuestion', 'questionNumbersForRows', 'questionNumbersReset', 'questionNumbersResetNumber',
  // Rows
  'rows[].id', 'rows[].type', 'rows[].label', 'rows[].position', 'rows[].variableName', 'rows[].codebookName', 'rows[].isExpanded', 'rows[].isCellExpanded', 'rows[].isVariablesExpanded',
  // Columns
  'columns[].id', 'columns[].type', 'columns[].label', 'columns[].width', 'columns[].position', 'columns[].headerPosition', 'columns[].isHeaderExpanded', 'columns[].isCellExpanded', 'columns[].isExpanded', 'columns[].template', 'columns[].templateSettings', 'columns[].isTemplateExpanded'].concat(result);
}();
exports.fields = fields;
var ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings;
  var result = ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.rows.map(function (item, index) {
    return "rows[".concat(index, "].label");
  })));
  result.push.apply(result, _toConsumableArray(settings.columns.map(function (item, index) {
    return "columns[".concat(index, "].label");
  })));
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (!value.ttsFields) {
      return "continue";
    }
    if (!settings.columnTypes[key]) {
      return "continue";
    }
    settings.columnTypes[key].forEach(function (item, index) {
      var columnTtsFields = typeof value.ttsFields === 'function' ? value.ttsFields({
        settings: item,
        isMatrixMode: true
      }) : value.ttsFields;
      result.push.apply(result, _toConsumableArray(columnTtsFields.map(function (name) {
        return "columnTypes.".concat(key, "[").concat(index, "].").concat(name);
      })));
    });
  };
  for (var _i = 0, _Object$entries = Object.entries(_columnTypes["default"]); _i < _Object$entries.length; _i++) {
    var _ret = _loop();
    if (_ret === "continue") continue;
  }
  return result;
};
exports.ttsFields = ttsFields;
var initialValues = {
  question: '<p><strong>What is your opinion about...?</strong></p>',
  addUserRowText: 'Add new row',
  userRowPlaceholder: 'Please specify',
  maxUserRows: '3',
  rowHeaderWidth: '30%',
  isBorderedStyle: true,
  isStripedRowsStyle: false,
  isStripedColumnsStyle: false,
  questionNumbersForMainQuestion: true,
  rows: [{
    id: 1,
    type: 'static',
    label: 'Row',
    position: 'top-left'
  }, {
    id: 2,
    type: 'static',
    label: 'Row',
    position: 'top-left'
  }, {
    id: 3,
    type: 'static',
    label: 'Row',
    position: 'top-left'
  }],
  rowTypes: {
    "static": [{
      id: 1
    }]
  },
  columns: [{
    id: 1,
    type: 'multipleChoice',
    label: '',
    position: 'top-left',
    headerPosition: 'top-left'
  }],
  columnTypes: {
    openEnded: [],
    checkbox: [],
    multipleChoice: [_objectSpread(_objectSpread({}, _cccisdSurveyMultipleChoice.builderInitialValues), {}, {
      id: 1,
      verticalOrHorizontal: 'horizontal',
      showLabelsInMatrixHeader: true
    })],
    slider: []
  }
};
exports.initialValues = initialValues;
var icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-th"
});
exports.icon = icon;
var validate = function validate(values) {
  var errors = {};
  (0, _forEach2["default"])(_columnTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.columnTypes[type], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      columnTypes: _objectSpread(_objectSpread({}, errors.columnTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  (0, _forEach2["default"])(_rowTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.rowTypes[type], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      rowTypes: _objectSpread(_objectSpread({}, errors.rowTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  if (values.allowUserRows) {
    if (values.minUserRows && !(0, _isInt["default"])(values.minUserRows, {
      min: 0,
      max: 15
    })) {
      errors.minUserRows = 'Value should be the number between 0 and 15';
    }
    if (!values.maxUserRows || !(0, _isInt["default"])(values.maxUserRows, {
      min: 1,
      max: 15
    })) {
      errors.maxUserRows = 'Value should be the number between 1 and 15';
    }
    if (!errors.minUserRows && !errors.maxUserRows) {
      if (values.maxUserRows * 1 < values.minUserRows * 1) {
        errors.maxUserRows = 'Max value should be greater than min value';
      }
    }
  }
  if (!values.questionNumbersHide && values.questionNumbersReset && !(0, _isInt["default"])(values.questionNumbersResetNumber, {
    min: 1,
    max: 9999
  })) {
    errors.questionNumbersResetNumber = 'Enter whole number from 1 to 9999';
  }
  return errors;
};
exports.validate = validate;
var getMetricsPrefix = function getMetricsPrefix() {
  return 'mx';
};
exports.getMetricsPrefix = getMetricsPrefix;
var getDataDefinitions = function getDataDefinitions(id, settings) {
  var question = settings.question,
    rows = settings.rows,
    columns = settings.columns,
    allowUserRows = settings.allowUserRows,
    maxUserRows = settings.maxUserRows;
  var metricsPrefix = getMetricsPrefix();
  var data = {};
  rows.forEach(function (row) {
    columns.forEach(function (column) {
      var prefix = id + '_answer_' + row.id + '_';
      if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getDataDefinitions) {
        var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        var dataDefinitions = _columnTypes["default"][column.type].getDataDefinitions(column.id, columnSettings, true);
        (0, _forEach2["default"])(dataDefinitions, function (value, key) {
          data[prefix + key] = _objectSpread(_objectSpread({}, value), {}, {
            reportHeader: "".concat(metricsPrefix, "_").concat(prefix).concat(value.reportHeader),
            title: (0, _cccisdSurveyCommon.stripTags)(question),
            titleHtml: question,
            subtitle1: (0, _cccisdSurveyCommon.stripTags)(row.label),
            subtitle1Html: row.label,
            subtitle2: (0, _cccisdSurveyCommon.stripTags)(column.label),
            subtitle2Html: column.label,
            matrixRow: row.id,
            matrixColumn: column.id
          });
        });
      }
    });
  });
  if (allowUserRows) {
    var _loop2 = function _loop2(i) {
      data["".concat(id, "_answer_user_row_").concat(i, "_text")] = {
        title: (0, _cccisdSurveyCommon.stripTags)(question),
        titleHtml: question,
        variableType: 'answer',
        reportHeader: "".concat(metricsPrefix, "_").concat(id, "_answer_user_row_").concat(i, "_text"),
        subtitle1: 'User row',
        subtitle1Html: '<p>User row</p>',
        matrixRow: "User Row ".concat(i, " Text"),
        matrixColumn: null,
        type: 'text',
        questionType: 'matrix',
        tags: {
          system: ['answer']
        }
      };
      columns.forEach(function (column) {
        var prefix = "".concat(id, "_answer_user_row_").concat(i, "_");
        if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getDataDefinitions) {
          var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
            id: column.id
          });
          var dataDefinitions = _columnTypes["default"][column.type].getDataDefinitions(column.id, columnSettings, true);
          (0, _forEach2["default"])(dataDefinitions, function (value, key) {
            data[prefix + key] = _objectSpread(_objectSpread({}, value), {}, {
              variableType: 'answer',
              reportHeader: "".concat(metricsPrefix, "_").concat(prefix).concat(value.reportHeader),
              title: (0, _cccisdSurveyCommon.stripTags)(question),
              titleHtml: question,
              subtitle1: 'User row',
              subtitle1Html: '<p>User row</p>',
              subtitle2: (0, _cccisdSurveyCommon.stripTags)(column.label),
              subtitle2Html: column.label,
              matrixRow: "User Row ".concat(i),
              matrixColumn: column.id
            });
          });
        }
      });
    };
    for (var i = 0; i < maxUserRows * 1; i++) {
      _loop2(i);
    }
  }
  return data;
};
exports.getDataDefinitions = getDataDefinitions;
var getMetrics = function getMetrics(id, settings) {
  var answer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rows = settings.rows,
    columns = settings.columns;
  var result = {};

  // Handle static rows
  rows.filter(function (item) {
    return item.type === 'static';
  }).forEach(function (row) {
    columns.forEach(function (column) {
      var prefix = id + '_answer_' + row.id + '_';
      if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getMetrics) {
        var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        var columnAnswer = answer["cell_".concat(row.id, "_").concat(column.id)];
        var metrics = _columnTypes["default"][column.type].getMetrics(column.id, columnSettings, columnAnswer);
        (0, _forEach2["default"])(metrics, function (value, key) {
          result[prefix + key] = value;
        });
      }
    });
  });

  // Handle user created rows
  if (answer.userRows) {
    answer.userRows.forEach(function (row, index) {
      result["".concat(id, "_answer_user_row_").concat(index, "_text")] = row.label;
      columns.forEach(function (column) {
        var prefix = "".concat(id, "_answer_user_row_").concat(index, "_");
        if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getMetrics) {
          var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
            id: column.id
          });
          var columnAnswer = row["column_".concat(column.id)];
          var metrics = _columnTypes["default"][column.type].getMetrics(column.id, columnSettings, columnAnswer);
          (0, _forEach2["default"])(metrics, function (value, key) {
            result[prefix + key] = value;
          });
        }
      });
    });
  }

  // Handle UserLists rows
  rows.filter(function (item) {
    return item.type === 'userList';
  }).forEach(function (row) {
    columns.forEach(function (column) {
      var prefix = id + '_answer_' + row.id + '_';
      if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getMetrics && answer["cell_".concat(row.id)]) {
        var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        answer["cell_".concat(row.id)].forEach(function (user) {
          var columnAnswer = user["column_".concat(column.id)];
          var metrics = _columnTypes["default"][column.type].getMetrics(column.id, columnSettings, columnAnswer);
          (0, _forEach2["default"])(metrics, function (value, key) {
            result[prefix + key] = result[prefix + key] || {};
            result[prefix + key].pawns = result[prefix + key].pawns || [];
            result[prefix + key].pawns.push({
              pawnId: user.pawnId,
              pawnHash: user.pawnHash,
              value: value
            });
          });
        });
      }
    });
  });
  return result;
};
exports.getMetrics = getMetrics;